import { API_BASE_URL } from "../../Utils/apiConfig";

export const reporteTarjetas = async () => {
  try {
    const token = localStorage.getItem("JWT");
    const codemisor = localStorage.getItem("CodEmisor");
    const response = await fetch(`${API_BASE_URL}/api/tarjetas?codemisor=${codemisor}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
        codemisor : codemisor,
      },
    });
    if (response.status === 403) {
      window.location.href = "/login";
    }
    if (response.ok) {
      const data = await response.json();
      return data;
    }      
    else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const reporteRegionesTarjetas = async () => {
  try {
    const token = localStorage.getItem("JWT");
    const codemisor = localStorage.getItem("CodEmisor"); 
    const response = await fetch(`${API_BASE_URL}/api/tarjetasregiones?codemisor=${codemisor}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
         codemisor : codemisor
      },
    });
    if (response.status === 403) {
      window.location.href = "/login";
    }
    if (response.ok) {
      const data = await response.json();
      return data;
    }      
    else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};